const { withNormalization } = require('./normalization');
const { validator } = require('./validation');

function numericComparator(fn) {
  return {
    test({ rule, params }) {
      const value = params[rule.parameter];
      return fn(value, rule.value);
    },
    validate: validator({
      '`parameter` property is required': rule => 'parameter' in rule,
      '`value` property is required': rule => 'value' in rule,
      '`parameter` must be a string': rule => typeof rule.parameter === 'string',
      '`value` must be a number': rule => typeof rule.value === 'number' 
    })
  };
}

const stringComparator = (property, fn) => withNormalization({
  normalize: rule => ({
    ...rule,
    [property]: rule.caseSensitive === true
      ? String(rule[property])
      : String(rule[property]).toLocaleLowerCase()
  }),
  test({ rule, params }) {
    const value = String(params[rule.parameter]);
    return fn(
      rule.caseSensitive === true ? value : value.toLocaleLowerCase(),
      rule[property]
    );
  },
  validate: validator({
    'parameter property is required': rule => 'parameter' in rule,
    [`${property} property is required`]: rule => property in rule,
    'parameter must be a string': rule => typeof rule.parameter === 'string',
    [`${property} must be a string`]: rule => typeof rule[property] === 'string',
    'caseSensitive must be a boolean': rule => !('caseSensitive' in rule) || typeof rule.caseSensitive === 'bool'
  })
});

module.exports = {
  numericComparator,
  stringComparator
};
